exports.msToISOString = function(ms) {
  const sec_num = parseInt(ms, 10) / 1000;
  let hours   = Math.floor(sec_num / 3600);
  let minutes = Math.floor((sec_num - (hours * 3600)) / 60);
  let seconds = sec_num - (hours * 3600) - (minutes * 60);
  seconds = seconds.toFixed(2);

  if (hours === 0) {
    hours = '';
  } else if (hours < 10) {
    hours = `0${hours}:`;
  } else {
    hours = `${hours}:`;
  }
  if (minutes < 10) {
    minutes = `0${minutes}`;
  }
  if (seconds < 10) {
    seconds = `0${seconds}`;
  }
  return `${hours}${minutes}' ${seconds}"`;
}



/** WEBPACK FOOTER **
 ** ./src/Common.js
 **/